module.exports = ["/question/{1-20}", "/demographics", "/results"];